import React from 'react';
import { TArrayFields } from '../../../api/blueprints/blueprint-details.types';
import Text from '../../global/text/text';

export interface IBlueprintArraySettingItemProps {
    settingMapperValueKeys: string[];
    settingMapperValues: Record<string, string>;
    settingValue: TArrayFields;
    paddingLeft: number;
}

const BlueprintArraySettingItem = ({
    settingMapperValueKeys,
    settingMapperValues,
    settingValue,
    paddingLeft
}: IBlueprintArraySettingItemProps) => {

    return (
        <div className='blueprint-list-item'>
            {
                settingMapperValueKeys.map(keyValue => {
                    return <div className={`p-left-${paddingLeft}px flex`} key={keyValue} >
                            <Text
                                tag='div'
                                className='blueprint-details--settings-item__title m-bottom-3px'
                                message={ `${settingMapperValues[keyValue]}: ` }
                            />
                            <Text
                                tag='div'
                                className='m-left-3px word-break'
                                message={ settingValue[keyValue] }
                            />
                        </div>;
                })
            }
        </div>
    );
};

export default BlueprintArraySettingItem;
